import styled from 'styled-components'

export const SearchBarWrapper = styled.div`
  width: 224px;
`
